module.exports = __webpack_public_path__ + "static/media/bestdishribbon.5fddf397.png";